// localStorage cache for ``GET /auth/debug`` (public, per-origin platform
// config). Startup reads it synchronously so the session bootstrap does not
// wait on that request; every successful fetch overwrites it, so a config
// change reaches the browser one page load later.
const AUTH_CONFIG_CACHE_KEY = 'specificai:authConfig:v1';

export const readCachedAuthConfig = () => {
    try {
        const parsed = JSON.parse(window.localStorage.getItem(AUTH_CONFIG_CACHE_KEY));
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch {
        return null;
    }
};

export const writeCachedAuthConfig = (config) => {
    try {
        window.localStorage.setItem(AUTH_CONFIG_CACHE_KEY, JSON.stringify(config));
    } catch {
        // Storage may be unavailable (private mode, quota); the cache is best-effort.
    }
};
